<template>
<div class="info">
	<div class="title">申请信息
		<a class="title-a" v-if="from=='policy'&&baseInfo.insurancePolicyStatus=='UNDERWRITING'" @click="toEdit">参加车辆编辑</a>
		<json-to-excel ref="jsonToExcel">
			<a class="title-a" v-if="from=='policy'" @click="excel">下载参加车辆</a>
		</json-to-excel>
		<a class="title-a" v-if="from=='policy'" @click="toRecord">批改记录</a>
	</div>
	
	<Form :label-width="120" ref="form" class="mt15">
		<FormItem label="保障起期：" class="w600" v-if="from=='confirm'">{{baseInfo.effectiveDateStart}}</FormItem>
		<FormItem label="保障止期：" class="w600" v-if="from=='confirm'">{{baseInfo.effectiveDateEnd}}</FormItem>
		<FormItem label="保障天数：" class="w600" v-if="from=='confirm'">{{baseInfo.effectiveDays}}天</FormItem>
		<p class="recognize-total mt10">共{{list.length}}辆</p>
		<div class="recognize-table mt10 pb20">
			<SchemeTable type="car"/>
			<e-table :list="list">
				<el-table-column prop="no" label="序号" width="70" align="center" fixed></el-table-column>
				<el-table-column prop="scheme" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
				<el-table-column prop="seatingCapacity" label="座位数" width="80"></el-table-column>
				<el-table-column prop="premium" label="保费（元）" width="120"></el-table-column>
				<el-table-column prop="carNumber" label="车牌号" width="120"></el-table-column>
				<el-table-column prop="engineNumber" label="发动机号" width="190"></el-table-column>
				<el-table-column prop="frameNumber" label="车架号" width="180"></el-table-column>
			</e-table>
		</div>
		<FormItem label="车辆行驶证：" class="mt15">
			<div class="upload" v-for="(item, index) in list" :key="index">
				<a :href="item.drivingLicensePhotoFront" target="_blank" class="upload-item">
					<img 
						:src="ossImg(item.drivingLicensePhotoFront,'s')" 
						v-show="item.drivingLicensePhotoFront" 
						width="100%" 
						style="display:block" />
					<p>{{item.carNumber}}</p>
				</a :href="" target="_blank">
				<a :href="item.drivingLicensePhotoEnd" target="_blank" class="upload-item">
					<img 
						:src="ossImg(item.drivingLicensePhotoEnd,'s')" 
						v-show="item.drivingLicensePhotoEnd" 
						width="100%" 
						style="display:block" />
					<p>{{item.carNumber}}</p>
				</a :href="" target="_blank">
			</div>
		</FormItem>
	</Form>

</div>
</template>
<script>
import SchemeTable from '../common/SchemeTable'
import JsonToExcel from '@/components/common/JsonToExcel'
import eTable from '@/components/common/eTable'
export default {
	components:{SchemeTable,JsonToExcel,eTable},
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		from:{
			type:String,
			default:'confirm'// confirm/order/policy
		},
		title:{
			type:String,
			default:'申请信息'
		}
	},
	data () {
		return {
		}
	},
	
	computed:{
	   days(){
			if(this.info.effectiveDateStart&&this.info.effectiveDateEnd){
				return this.getDays(this.formatDate(this.info.effectiveDateStart),this.formatDate(this.info.effectiveDateEnd));
			}else {
				return ""
			}
		},
		baseInfo(){
			return this.info.baseInfo||{}
		},
		list(){
			return this.info.extraInfo||[]
		},
	},
	created(){
		if(this.from!='confirm'){
			if(this.columns=='policy'){
				this.columns.push({title: '保障状态',key: 'effectiveStatusDesc',width:120},)
			}
			this.columns=this.columns.concat([
				{title: '保障起期',key: 'effectiveDateStart',width:120},
				{title: '保障止期',key: 'effectiveDateEnd',width:120},
				{title: '备注',key: 'remark',width:160},
			])
		}
	},
	methods: {
		hideIdCard (str,frontLen=4,endLen=3) { 
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		toEdit () {
			this.$axios.post('broker/insurance/endorse/preCheck',{
				insurancePolicyId:this.baseInfo.id
			}).then(res=>{
				this.$router.push(`/truck-employer/edit/car/${this.baseInfo.id}`)
			});
		},
		// 导出
		excel () {
			this.$refs.jsonToExcel.download({
				header:['序号','保障方案','座位数','保费（元）','车牌号','发动机号','车架号','保障起期','保障止期','备注'],
				props:['no','scheme','seatingCapacity','premium','carNumber','engineNumber','frameNumber','effectiveDateStart','effectiveDateEnd','remark'],
				data:this.list,
				fileName:this.baseInfo.productName+'参加车辆'
			})
		},
		toRecord(){
			this.$router.push(`/truck-employer/edit-record/car/${this.baseInfo.id}`)
		}
	},
}
</script>
<style scoped lang="less">
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
	.upload{
		margin-right: 20px;
		display: inline-block;
		&-item{
			width: 100px;
			display: inline-block;
			margin-right: 10px;
			margin-bottom: 10px;
			text-align: center;
			&-content{
				padding:10px 0;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/car/RecognizeInfo.vue